import Table from '../../../components/Table';
import Modal from '../../../components/Modal';
import {
  Box,
  Flex,
  Alert,
  Button,
  Drawer,
  Text,
  Tooltip,
  Input,
  ActionIcon,
  CloseButton
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useParams, useNavigate } from 'react-router';
import { CreateProjectModalContainer } from '../style';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createStyles } from '@mantine/emotion';
import { usePeriodById } from '../../../services/period.service';
import { useSearchParams } from 'react-router-dom';
import { useGetWorkflowById, useUpdateWorkflow } from '../../../services/workflow.services';
import { EditableProjectName } from '../../../components/EditableProjectName';
import {
  serviceFundMapping,
  useCreateFund,
  useCreateFundsBulk,
  useDeletFundFile,
  useGetFilesByPeriodId,
  useGetFundsByPeriodId,
  useSetPasswordToFile,
  useUploadFundFiles
} from '../../../services/funds.service';
import toast from 'react-hot-toast';
import { FundRow } from './components/FundRow';
import UncheckIcon from '../../../assets/icons/uncheck.svg?react';
import { useUserGroups, useUserGroupsCurrentUserAdminState } from '../../../services/user.service';
import { useFeatureFlag, FEATURE_FLAG_NAMES } from '../../../hooks/useFeatureFlag';
import { PasswordModal } from './components/PasswordModal';
import protectedFile from '../../../assets/images/protected-file.png';
import { SkipPasswordModal } from './components/SkipPasswordModal';
import {
  useGetFormPFJurisdiction,
  useGetJurisdictions
} from '../../../services/jurisdiction.service';
import { LoadingCircle } from './icons';
import { checkIsLockedAutomation } from '../../../utils/lockAutomation';
import reportStore from '../UploadFiles/store';
import { TbCheck, TbPencil, TbPlus, TbUpload } from 'react-icons/tb';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { AddAIFs } from './components/AddAIFs';
import { NewDeleteConfirmModal } from '../../../components/NewDeleteConfirmModal';
import agentStore from '../../../store/agent';
import { WEB_PAGE_STATE_ENUMS } from '../../../components/ChatWidget/constants';
import { DropZone } from '../../../components/DropZone';
import { PermissionGuard } from '../../../components/PermissionGuard';
import { permissionPolicies } from '../../../permissions/policies';
import { getWorkflowDropzoneAccept, getWorkflowFileAccept } from '../../../consts/fileTypes';
import { REPORT_NAMINGS, REPORT_TYPES } from '../../../consts/reportTypes';
import { detectDuplicateFiles } from '../../../utils/fileDeduplication';
import { DuplicateFilesModal } from '../../../components/DuplicateFilesModal';
import { extractApiError } from '../../../utils';
import {
  useCreateConnectSession,
  buildConnectUiUrl,
  useImportCloudFiles,
  useIntegrationConnections,
  useIntegrationFiles
} from '../../../services/integrations.service';
import AddFilesSourceModal from '../components/AddFilesSourceModal';
import CloudImportModal from '../components/CloudImportModal';
import {
  getConnectedProviderKeys,
  getPreviewIntegrationCards,
  getProviderConnections
} from '../../../consts/integrationsCatalog';
import { useWorkflowChrome } from '../../../components/Layout/WorkflowChromeContext';
import { useSignalRListener } from '../../../hooks/useSignalR';
import { SIGNALR_LISTENERS } from '../../../config/signalr';

const CheckIcon = ({ ...props }) => (
  <svg
    {...props}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.23525 6.46695C2.66958 4.61534 4.11534 3.16958 5.96696 2.73525C7.30417 2.42158 8.69583 2.42158 10.033 2.73525C11.8847 3.16958 13.3304 4.61534 13.7647 6.46696C14.0784 7.80417 14.0784 9.19583 13.7647 10.533C13.3304 12.3847 11.8847 13.8304 10.033 14.2647C8.69583 14.5784 7.30417 14.5784 5.96696 14.2647C4.11534 13.8304 2.66958 12.3847 2.23525 10.533C1.92158 9.19583 1.92158 7.80417 2.23525 6.46695Z"
      fill="#7888F5"
    />
    <path
      d="M6.16666 8.33268L7.49999 9.66602L9.83332 7.16602"
      stroke="#EDF0F5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckBox = ({ checked, onChange }) => {
  if (checked) return <CheckIcon onClick={onChange} />;
  return <UncheckIcon onClick={onChange} />;
};

const useStyles = createStyles(theme => ({
  borderedBox: {
    border: `1px solid ${theme.colors.gray[1]}`,
    padding: theme.spacing.md,
    borderRadius: '4px',
    background: '#fff',
    marginTop: '12px'
  }
}));

const completedStatus = ['completed', 'mapped', 'failed', 'waiting for mapping'];

export default function ProjectFunds() {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const uploadRef = useRef();
  const [openedAddAIFs, { open: openAddAIFs, close: closeAddAIFs }] = useDisclosure(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const periodId = searchParams.get('periodId');
  const createFund = useCreateFund();
  const uploadFundFiles = useUploadFundFiles();
  const deleteFundFile = useDeletFundFile();
  const updateProject = useUpdateWorkflow({});
  const createFundBulk = useCreateFundsBulk();

  const { data: groups, isLoading: isLoadingCompany } = useUserGroups();

  const currentGroupId = groups?.current_company_id;

  const [data, setData] = useState();
  const [protectedFiles, setProtectedFiles] = useState([]);
  const [protectedFileNumber, setProtectedFileNumber] = useState(null);
  const [isSkipPasswordModalOpen, setIsSkipPasswordModalOpen] = useState(false);
  const [expression, setExpression] = useState('');

  const disableFundFetch = data && data?.length > 0 && !data.some(el => el.name);

  const { data: project, refetch: refetchWorkflow } = useGetWorkflowById({
    id: projectId,
    queryParams: {
      enabled: !!currentGroupId
    },
    params: {
      headers: {
        company_id: currentGroupId
      }
    }
  });

  const isCustomReportType = project?.report_type === REPORT_TYPES.CUSTOM;
  const isFormPFReportType = project?.report_type === REPORT_TYPES.FORM_PF;
  const isConversionReportType = project?.report_type === REPORT_TYPES.CONVERSION;
  const acceptedFileTypes = getWorkflowFileAccept(project?.report_type);
  const acceptedDropzoneTypes = getWorkflowDropzoneAccept(project?.report_type);

  const shouldFetchEuropeanJurisdictions = useMemo(() => {
    if (!project?.report_type) return false;
    // we don't have jurisdictions for CUSTOM type
    if (isCustomReportType) return false;
    // for FormPF we have its own jurisdictions endpoint
    if (isFormPFReportType) return false;

    // for ANNEX_IV and CONVERSION
    return true;
  }, [project?.report_type, isCustomReportType, isFormPFReportType]);

  const { data: currentUser } = useUserGroupsCurrentUserAdminState();

  const canManageWorkflow = permissionPolicies.checkAccess({
    currentUserRole: currentUser?.role,
    currentUserId: currentUser?.azure_object_id,
    assignedTo: project?.assigned_to
  });

  const { data: period, refetch: refetchPeriod } = usePeriodById({
    periodId,
    params: {
      headers: {
        company_id: currentGroupId,
        project_id: project?.id
      }
    },
    queryParams: {
      enabled: !!project?.id && !!currentGroupId
    }
  });

  // For Europe
  const { data: jurisdictions, refetch: refetchJurisdictions } = useGetJurisdictions({
    periodId,
    queryParams: {
      enabled: shouldFetchEuropeanJurisdictions
    }
  });

  // For USA
  const { data: formPFJurisdiction } = useGetFormPFJurisdiction({
    periodId,
    queryParams: {
      enabled: isFormPFReportType && !!periodId
    }
  });

  const {
    data: funds,
    refetch,
    isLoading
  } = useGetFundsByPeriodId({
    periodId,
    params: {
      headers: {
        company_id: currentGroupId,
        project_id: project?.id
      }
    },
    queryParams: {
      enabled: !!period?.id && !!currentGroupId && !!project?.id && !disableFundFetch,
      // SignalR (FileProcessingUpdate) drives live refreshes; this is a
      // long-interval safety net for missed messages.
      refetchInterval: 60000,
      onSuccess: res => {
        if (!protectedFiles.length) {
          const bulkUploads = res?.[0]?.bulk_uploaded_files || [];
          const individualUploads = res?.map(el => el.files_as_per_input).flat();

          const _protectedFiles = [...bulkUploads, ...individualUploads].filter(
            _file => _file.is_password_protected && !_file.has_password
          );

          if (_protectedFiles.length) {
            setProtectedFileNumber(0);
            setIsSkipPasswordModalOpen(true);
          }

          setProtectedFiles(_protectedFiles);
        }

        return res;
      }
    }
  });

  const { refetch: refetchFiles } = useGetFilesByPeriodId({
    periodId,
    queryParams: {
      enabled: isCustomReportType && funds?.length === 0,
      // SignalR (FileProcessingUpdate) drives live refreshes; 60s heartbeat
      // as the safety net while waiting for first files in Custom flow.
      refetchInterval: isCustomReportType && funds?.length === 0 ? 60000 : false,
      onSuccess: res => {
        if (!protectedFiles.length) {
          const _protectedFiles = [...res].filter(
            _file => _file.is_password_protected && !_file.has_password
          );

          if (_protectedFiles.length) {
            setProtectedFileNumber(0);
            setIsSkipPasswordModalOpen(true);
          }

          setProtectedFiles(_protectedFiles);
        }
        setData([{ bulk_uploaded_files: [...res], id: null, name: null, period_id: periodId }]);
        return res;
      }
    }
  });

  const showCustomReportTypeTable = isCustomReportType && funds?.length === 0;

  const { isLockedPeriod, setIsLockedPeriod } = reportStore;
  const isLastPeriod = project?.periods?.[0]?.id === periodId;

  useEffect(() => {
    if (!period || !currentUser) return;

    setIsLockedPeriod(
      checkIsLockedAutomation(period, currentUser) ||
        (!isLastPeriod && currentUser?.role !== 'Admin')
    );
  }, [period, currentUser, isLastPeriod]);

  const [isOpenCreateModal, setOpenIsCreateModal] = useState();
  const [fundName, setFundName] = useState();
  const [projectName, setProjectName] = useState('');
  const [deletableFile, setDeletableFile] = useState();
  const [workflowName, setWorkflowName] = useState();
  const [isOpenEditProject, setIsOpenEditProject] = useState(false);
  const [allFiles, setAllFiles] = useState([]);
  const [selectedFundIds, setSelectedFundIds] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploadingFiles, setIsUploadingFiles] = useState(false);
  const [isDeletingAllProtectedFiles, setIsDeletingAllProtectedFiles] = useState(false);
  const [duplicateFiles, setDuplicateFiles] = useState([]);
  const [pendingUploadFiles, setPendingUploadFiles] = useState(null);
  const [isCheckingDuplicates, setIsCheckingDuplicates] = useState(false);
  const [fileHashMap, setFileHashMap] = useState({});
  const [isCloudModalOpen, setIsCloudModalOpen] = useState(false);
  const [isAddFilesModalOpen, setIsAddFilesModalOpen] = useState(false);
  const isCloudIntegrationEnabled = useFeatureFlag(
    FEATURE_FLAG_NAMES.FILE_UPLOAD_CLOUD_INTEGRATION
  );
  const [selectedProvider, setSelectedProvider] = useState('');
  const [selectedConnectionId, setSelectedConnectionId] = useState('');
  const [selectedCloudFiles, setSelectedCloudFiles] = useState([]);
  const [cloudQuery, setCloudQuery] = useState('');
  const [cloudPath, setCloudPath] = useState('');
  const [cloudFolderId, setCloudFolderId] = useState('');
  const [cloudFolderIdTrail, setCloudFolderIdTrail] = useState([]);
  const [cloudFolderTrail, setCloudFolderTrail] = useState([]);

  const providers = useMemo(() => getPreviewIntegrationCards(), []);

  const createConnectSession = useCreateConnectSession();
  const importCloudFiles = useImportCloudFiles();
  const {
    data: connectionsData,
    refetch: refetchConnections,
    isFetching: isFetchingConnections
  } = useIntegrationConnections({
    queryOptions: {
      enabled: isCloudModalOpen
    }
  });

  const allConnections = useMemo(() => connectionsData?.connections || [], [connectionsData]);
  const selectedProviderConnections = useMemo(
    () => getProviderConnections(allConnections, selectedProvider),
    [allConnections, selectedProvider]
  );
  const connectedProviders = useMemo(
    () =>
      providers.filter(provider => getConnectedProviderKeys(allConnections).includes(provider.key)),
    [allConnections, providers]
  );

  const {
    data: cloudFilesData,
    refetch: refetchCloudFiles,
    isFetching: isFetchingCloudFiles
  } = useIntegrationFiles({
    params:
      selectedProvider === 'google-drive' || selectedProvider === 'sharepoint-online'
        ? {
            provider_key: selectedProvider,
            connection_id: selectedConnectionId,
            query: cloudQuery || undefined,
            folder_id: cloudFolderId || undefined
          }
        : {
            provider_key: selectedProvider,
            connection_id: selectedConnectionId,
            query: cloudQuery || undefined,
            path: cloudPath || undefined
          },
    queryOptions: {
      enabled: !!selectedProvider && !!selectedConnectionId && isCloudModalOpen
    }
  });

  const isAllFundsSelected = useMemo(() => {
    return selectedFundIds?.length === funds?.length;
  }, [selectedFundIds, funds]);

  const setPasswordToFile = useSetPasswordToFile();

  const hasUncompletedFiles = useMemo(() => {
    let count = 0;
    const _files = [];

    data?.forEach(item => {
      item?.bulk_uploaded_files?.forEach(file => {
        if (
          !completedStatus.includes(file.status) &&
          (!file.is_password_protected || file.has_password)
        )
          count++;

        _files.push(file);
      });

      item?.files_as_per_input?.forEach(file => {
        if (
          !completedStatus.includes(file.status) &&
          (!file.is_password_protected || file.has_password)
        )
          count++;
        _files.push(file);
      });
    });

    setAllFiles(_files);

    if (_files?.length === 0) return true;

    return count > 0;
  }, [data]);

  const postSkipFiles = useCallback(() => {
    if (protectedFileNumber < protectedFiles.length - 1) {
      setProtectedFileNumber(prev => prev + 1);
    } else {
      // FileProcessingUpdate listener refetches the funds list after the
      // last deleted file's event arrives.
      setIsSkipPasswordModalOpen(false);
      setProtectedFiles([]);
      setProtectedFileNumber(0);
    }
  }, [protectedFiles, protectedFileNumber, refetchPeriod]);

  const clear = useCallback(() => {
    refetch?.();
    refetchPeriod?.();
    setIsSkipPasswordModalOpen(false);
    setProtectedFiles([]);
    setProtectedFileNumber(0);
  }, [refetchPeriod]);

  const onSkipAllFiles = useCallback(() => {
    setIsDeletingAllProtectedFiles(true);
    Promise.all(
      protectedFiles.map(file => serviceFundMapping.deleteFundFile({ fileId: file.id, periodId }))
    )
      .then(() => {
        clear();
      })
      .catch(err => {
        toast.error(err?.detail?.message || 'Error on deleting file');
      })
      .finally(() => {
        setIsDeletingAllProtectedFiles(false);
      });
  }, [protectedFiles, protectedFileNumber, periodId, postSkipFiles, deleteFundFile.mutate]);

  const onSkipFile = useCallback(() => {
    const currentFile = protectedFiles[protectedFileNumber];

    deleteFundFile.mutate(
      {
        fileId: currentFile.id,
        periodId
      },
      {
        onSuccess: () => {
          postSkipFiles();
        },
        onError: err => {
          toast.error(extractApiError(err, 'Unable to delete this fund file.'));
        }
      }
    );
  }, [protectedFiles, protectedFileNumber, periodId, postSkipFiles]);

  const onUnblockSkipFile = useCallback(
    pwd => {
      const currentFile = protectedFiles[protectedFileNumber];

      setPasswordToFile.mutate(
        {
          periodId,
          fileId: currentFile?.id,
          data: {
            password: pwd
          }
        },
        {
          onSuccess: () => {
            // FileProcessingUpdate listener handles refetch.
            toast.success('Successfuly unlocked');
            postSkipFiles();
          },
          onError: err => {
            toast.error(extractApiError(err, 'Unable to unlock this file.'));
          }
        }
      );
    },
    [protectedFiles, protectedFileNumber, periodId, postSkipFiles]
  );

  const handleToggleSelectedFund = els => {
    setSelectedFundIds(prev => {
      if (prev.includes(els)) return prev.filter(fundId => fundId !== els);
      return [...new Set([...prev, els])];
    });
  };

  useEffect(() => {
    if (!project || !project?.name) return;

    setWorkflowName(project?.name);
  }, [project]);

  useEffect(() => {
    setData(funds);
  }, [funds]);

  useSignalRListener(SIGNALR_LISTENERS.ON_FILE_PROCESSING_UPDATED, data => {
    if (data?.period_id && data.period_id !== periodId) return;
    // Any file-level transition (upload, process, delete, password,
    // sheet/preview extract) affects either the funds list (per-fund file
    // arrays) or the standalone files list (Custom flow's pre-fund state).
    refetch();
    if (isCustomReportType) refetchFiles();
  });

  const handleUploadFundFiles = (files, fundId) => {
    const formData = new FormData();

    [...files].forEach(file => formData.append('files', file));

    toast.promise(uploadFundFiles.mutateAsync({ data: formData, periodId, fundId }), {
      loading: 'Uploading...',
      success: res => {
        // Immediate refetch so the new file row appears synchronously after
        // upload — the FileProcessingUpdate listener handles subsequent
        // processing transitions. Jurisdictions has no event, so manual.
        refetch();
        refetchJurisdictions();
        // Re-fetch period so the WorkflowStepper's `file_count` sub-label
        // reflects the new files immediately.
        refetchPeriod();
        return 'Uploaded';
      },
      error:
        'Something went wrong while uploading files. Please make sure that you have proper permissions'
    });
  };

  // clears out draft fund rows which are not yet saved to the BE database
  const clearUnsavedFunds = useCallback(() => {
    setData(prev => [...prev.filter(el => el.id !== null)]);
  }, [data]);

  const _columns = useMemo(() => {
    return [
      {
        title: 'Name',
        key: 'name',
        tdProps: {
          style: {
            padding: 0
          }
        },
        thStyle: {
          textAlign: 'left'
        },
        renderHeadCell: () => {
          return (
            <Flex align="center" justify="space-between" w="100%">
              <Text fz="sm" c="gray.6" fw="600">
                Added {REPORT_NAMINGS.FUND?.[project?.report_type]}s
              </Text>
              <Text
                style={{
                  whiteSpace: 'nowrap'
                }}
                fz="sm"
                c="gray.6"
                fw="600"
              >
                {funds?.length > 0
                  ? `${funds?.length} ${REPORT_NAMINGS.FUND[project?.report_type]}s`
                  : ''}
              </Text>
            </Flex>
          );
        },
        render: data => {
          return (
            <FundRow
              onSelectProtectedFile={el => setSelectedFile(el)}
              clearUnsavedFunds={clearUnsavedFunds}
              defaultValue={data?.name}
              fundId={data?.id}
              refetch={() => {
                refetch();
                refetchJurisdictions();
              }}
              reportType={project?.report_type}
              periodId={periodId}
              isDummy={data?.isDummy}
              disableActions={isLockedPeriod}
              canManageWorkflow={canManageWorkflow}
              onUploadFundFiles={handleUploadFundFiles}
              individualFiles={data?.files_as_per_input}
              bulkFiles={data?.bulk_uploaded_files}
              onDelete={file => setDeletableFile(file)}
              isSelected={selectedFundIds?.includes(data?.id)}
              handleSelect={() => handleToggleSelectedFund(data?.id)}
              onImportFromIntegration={openCloudModal}
              isCloudIntegrationEnabled={isCloudIntegrationEnabled}
            />
          );
        }
      }
    ];
  }, [funds, data, isAllFundsSelected, selectedFundIds, project]);

  const _customReportColumns = useMemo(() => {
    return [
      {
        title: 'Name',
        key: 'name',
        tdProps: {
          style: {
            padding: 0
          }
        },
        thStyle: {
          textAlign: 'left'
        },
        renderHeadCell: () => {
          return (
            <Flex align="center" justify="space-between" w="100%">
              <Text fz="sm" c="gray.6" fw="600">
                {isCustomReportType
                  ? 'Added Files'
                  : `Added ${REPORT_NAMINGS.FUND?.[project?.report_type]}s`}
              </Text>
              <Text
                style={{
                  whiteSpace: 'nowrap'
                }}
                fz="sm"
                c="gray.6"
                fw="600"
              >
                {funds?.length > 0
                  ? `${funds?.length} ${REPORT_NAMINGS.FUND[project?.report_type]}s`
                  : ''}
              </Text>
            </Flex>
          );
        },
        render: data => {
          return (
            <FundRow
              onSelectProtectedFile={el => setSelectedFile(el)}
              clearUnsavedFunds={clearUnsavedFunds}
              defaultValue={data?.name}
              fundId={data?.id}
              refetch={() => {
                refetch();
                refetchFiles();
              }}
              hideInput={isCustomReportType}
              hideBadge={isCustomReportType}
              reportType={project?.report_type}
              periodId={periodId}
              isDummy={data?.isDummy}
              disableActions={isLockedPeriod}
              canManageWorkflow={canManageWorkflow}
              onUploadFundFiles={handleUploadFundFiles}
              individualFiles={data?.files_as_per_input}
              bulkFiles={data?.bulk_uploaded_files}
              onDelete={file => setDeletableFile(file)}
              isSelected={selectedFundIds?.includes(data?.id)}
              handleSelect={() => handleToggleSelectedFund(data?.id)}
              onImportFromIntegration={openCloudModal}
              isCloudIntegrationEnabled={isCloudIntegrationEnabled}
            />
          );
        }
      }
    ];
  }, [data, isAllFundsSelected, selectedFundIds]);

  const handleDelete = successFn => {
    deleteFundFile.mutate(
      { fileId: deletableFile.id, periodId },
      {
        onSuccess: () => {
          // FileProcessingUpdate listener refetches funds.
          refetchJurisdictions();
          // Re-fetch period so the WorkflowStepper's `file_count` sub-label
          // drops the deleted file from its total.
          refetchPeriod();
          setDeletableFile();
          successFn();
          toast.success('File deleted successfully');
        },
        onError: err => {
          toast.error(extractApiError(err, 'Unable to delete this file.'));
        }
      }
    );
  };

  // Build hash map from existing files when data changes
  useEffect(() => {
    if (!data || data.length === 0) {
      setFileHashMap({});
      return;
    }

    const newHashMap = {};
    data.forEach(item => {
      [...(item?.bulk_uploaded_files || []), ...(item?.files_as_per_input || [])].forEach(file => {
        newHashMap[file.id] = {
          name: file.name,
          size: file.size,
          chunkHash: file.chunkHash,
          status: file.status
        };
      });
    });
    setFileHashMap(newHashMap);
  }, [data]);

  const proceedWithBulkUpload = filesArray => {
    const totalFiles = filesArray.length;
    const formData = new FormData();
    filesArray.forEach(file => formData.append('files', file));

    let uploadedCount = 0;

    const toastId = toast.loading(`Uploading ${uploadedCount}/${totalFiles}`, {
      style: { width: 200 },
      icon: <LoadingCircle />,
      position: 'top-center'
    });

    setIsUploadingFiles(true);

    uploadFundFiles.mutate(
      {
        data: formData,
        periodId,
        onUploadProgress: data => {
          let cumulativeSize = 0;
          filesArray.forEach((file, idx) => {
            cumulativeSize += file.size;
            if (data.loaded >= cumulativeSize) {
              uploadedCount = idx + 1;
            }
          });
          toast.loading(`Uploading ${Math.min(uploadedCount, totalFiles)}/${totalFiles}`, {
            id: toastId,
            position: 'top-center'
          });
        }
      },
      {
        onSuccess: () => {
          // Immediate refetch so the new file rows appear synchronously
          // after upload — FileProcessingUpdate handles later transitions.
          if (isCustomReportType) {
            refetchFiles();
          } else {
            refetch();
            refetchJurisdictions();
          }
          toast.dismiss(toastId);
          toast.success('All files uploaded successfully!', { position: 'top-center' });
        },
        onError: err => {
          toast.dismiss(toastId);
          const detail = err?.data?.detail;

          if (
            err?.status === 415 &&
            typeof detail === 'string' &&
            detail.includes('Unsupported Media Type')
          ) {
            toast.error('Unsupported file format. Please upload an Excel or CSV file.', {
              position: 'top-center'
            });
          } else {
            toast.error(extractApiError(err, 'Failed to upload files.'), {
              position: 'top-center'
            });
          }
        },
        onSettled: () => {
          if (uploadRef.current) uploadRef.current.value = '';
          setIsUploadingFiles(false);
        }
      }
    );
  };

  const bulkUploadFiles = async e => {
    if (!canManageWorkflow) return;
    const { files } = e.target;
    if (!files.length) return;

    const filesArray = Array.from(files);
    const existingFiles = Object.values(fileHashMap);

    if (existingFiles.length > 0) {
      setIsCheckingDuplicates(true);
      try {
        const duplicates = await detectDuplicateFiles(filesArray, existingFiles);
        if (duplicates.length > 0) {
          setDuplicateFiles(duplicates);
          setPendingUploadFiles(filesArray);
          setIsCheckingDuplicates(false);
          e.target.value = '';
          return;
        }
      } catch (err) {
        console.error('Error checking duplicates:', err);
        toast.error('Error checking for duplicate files. Proceeding with upload.');
      }
      setIsCheckingDuplicates(false);
    }

    proceedWithBulkUpload(filesArray);
  };

  const handleDuplicateModalProceed = selectedFiles => {
    if (pendingUploadFiles && pendingUploadFiles.length > 0) {
      const duplicateNames = new Set(duplicateFiles.map(d => `${d.fileName}::${d.fileSize}`));
      const nonDuplicates = pendingUploadFiles.filter(
        file => !duplicateNames.has(`${file.name}::${file.size}`)
      );
      const filesToUpload = [...nonDuplicates, ...selectedFiles];
      setDuplicateFiles([]);
      setPendingUploadFiles(null);
      if (filesToUpload.length > 0) {
        proceedWithBulkUpload(filesToUpload);
      }
    }
  };

  const handleAddFund = () => {
    createFund.mutate(
      {
        periodId,
        data: {
          name: fundName
        }
      },
      {
        onSuccess: res => {
          setOpenIsCreateModal(false);
          setFundName('');
          if (isCustomReportType) {
            refetchFiles();
          } else {
            refetch();
          }
        },
        onError: err => {
          console.log(err);
        }
      }
    );
  };

  const handleCloseAddAifs = () => {
    closeAddAIFs();
    setExpression('');
  };

  const handleCreateFunds = names => {
    createFundBulk.mutate(
      { periodId, data: { names } },
      {
        onSuccess: () => {
          if (isCustomReportType) {
            refetchFiles();
          } else {
            refetch();
          }

          handleCloseAddAifs();
          toast.success('Fund added successfully');
        },
        onError: err => {
          toast.error(extractApiError(err, 'Unable to add these funds.'));
        }
      }
    );
  };

  const openAddFilesModal = () => setIsAddFilesModalOpen(true);
  const closeAddFilesModal = () => setIsAddFilesModalOpen(false);

  const handleAddFromLocal = () => {
    closeAddFilesModal();
    onOpenBulkUpload();
  };

  const handleAddFromIntegration = () => {
    closeAddFilesModal();
    openCloudModal();
  };

  const openCloudModal = () => {
    setIsCloudModalOpen(true);
    setSelectedCloudFiles([]);
    setCloudPath('');
    setCloudFolderId('');
    setCloudFolderIdTrail([]);
    setCloudFolderTrail([]);
  };

  const closeCloudModal = () => {
    setIsCloudModalOpen(false);
    setSelectedCloudFiles([]);
    setCloudQuery('');
    setCloudPath('');
    setCloudFolderId('');
    setCloudFolderIdTrail([]);
    setCloudFolderTrail([]);
  };

  const prevConnectionIdsRef = useRef(null);

  const handleConnectProvider = async providerKey => {
    try {
      const response = await createConnectSession.mutateAsync({
        allowed_integrations: [providerKey]
      });
      const connectLink = buildConnectUiUrl(response);

      prevConnectionIdsRef.current = new Set(allConnections.map(c => c.connection_id));

      if (connectLink) {
        window.open(connectLink, '_blank', 'noopener,noreferrer');
      }
      setSelectedProvider('');
      setSelectedConnectionId('');
      setSelectedCloudFiles([]);
      setCloudPath('');
    } catch (err) {
      toast.error('Failed to create connect session');
    }
  };

  useEffect(() => {
    if (!isCloudModalOpen) return;

    const refreshAndAutoSelect = async () => {
      const result = await refetchConnections();
      if (prevConnectionIdsRef.current !== null) {
        const newConnections = result.data?.connections || [];
        const newConn = newConnections.find(
          c => !prevConnectionIdsRef.current.has(c.connection_id)
        );
        if (newConn) {
          setSelectedConnectionId(newConn.connection_id);
          prevConnectionIdsRef.current = null;
        }
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refreshAndAutoSelect();
      }
    };

    window.addEventListener('focus', refreshAndAutoSelect);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('focus', refreshAndAutoSelect);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isCloudModalOpen, refetchConnections]);

  const toggleCloudFile = file => {
    setSelectedCloudFiles(prev => {
      const exists = prev.some(item => item.id === file.id);
      if (exists) return prev.filter(item => item.id !== file.id);
      return [...prev, file];
    });
  };

  const normalizeCloudPath = path => {
    if (!path) return '';

    let normalizedPath = path.trim();

    if (normalizedPath.includes('/drive/root:')) {
      normalizedPath = normalizedPath.split('/drive/root:', 2)[1];
    } else if (normalizedPath.startsWith('drive/root:')) {
      normalizedPath = normalizedPath.split('drive/root:', 2)[1];
    }

    if (normalizedPath.endsWith(':')) {
      normalizedPath = normalizedPath.slice(0, -1);
    }

    if (!normalizedPath || normalizedPath === '/') return '';

    return normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`;
  };

  const getParentCloudPath = path => {
    const segments = normalizeCloudPath(path).split('/').filter(Boolean);

    if (segments.length <= 1) return '';

    return `/${segments.slice(0, -1).join('/')}`;
  };

  const isCloudFolderNavigationEnabled = true;

  const visibleCloudFiles = useMemo(() => {
    const items = cloudFilesData?.items || [];
    const normalizedQuery = cloudQuery.trim().toLowerCase();

    if (!normalizedQuery) return items;

    return items.filter(file => file?.name?.toLowerCase().includes(normalizedQuery));
  }, [cloudFilesData?.items, cloudQuery]);

  const handleCloudItemClick = file => {
    if (file?.is_folder && isCloudFolderNavigationEnabled) {
      if (selectedProvider === 'google-drive' || selectedProvider === 'sharepoint-online') {
        setCloudFolderId(file.id);
        setCloudFolderIdTrail(prev => [...prev, file.id].filter(Boolean));
        setCloudFolderTrail(prev => [...prev, file.name].filter(Boolean));
        setCloudPath(prev =>
          [...prev.split('/').filter(Boolean), file.name].filter(Boolean).join('/')
        );
      } else {
        setCloudPath(prev => {
          const nextPath = `${prev || ''}/${file?.name || ''}`.replace(/\/+/g, '/');
          return nextPath;
        });
      }

      setSelectedCloudFiles([]);
      setCloudQuery('');
      return;
    }

    if (file?.is_folder) return;

    toggleCloudFile(file);
  };

  const handleCloudBack = () => {
    if (selectedProvider === 'google-drive' || selectedProvider === 'sharepoint-online') {
      setCloudFolderTrail(prev => prev.slice(0, -1));
      setCloudFolderIdTrail(prev => {
        const nextTrail = prev.slice(0, -1);
        setCloudFolderId(nextTrail[nextTrail.length - 1] || '');
        return nextTrail;
      });
    }

    setCloudPath(prev => getParentCloudPath(prev));
    setSelectedCloudFiles([]);
    setCloudQuery('');
  };

  const handleImportCloudFiles = async () => {
    if (!selectedConnectionId || selectedCloudFiles.length === 0) {
      toast.error('Select connection and at least one file');
      return;
    }

    try {
      await importCloudFiles.mutateAsync({
        periodId,
        data: {
          provider_key: selectedProvider,
          connection_id: selectedConnectionId,
          files: selectedCloudFiles
            .filter(file => !file.is_folder)
            .map(file => ({
              external_file_id: file.id,
              name: file.name,
              mime_type: file.mime_type,
              size: file.size,
              drive_id: file.drive_id,
              path: file.path,
              version: file.version
            }))
        }
      });

      toast.success('Cloud files imported successfully');
      closeCloudModal();
      // Immediate refetch so the imported file rows appear synchronously —
      // FileProcessingUpdate handles later processing transitions.
      if (isCustomReportType) {
        refetchFiles();
      } else {
        refetch();
      }
    } catch (err) {
      toast.error('Failed to import cloud files');
    }
  };

  const handleUnblockFile = pwd => {
    setPasswordToFile.mutate(
      {
        periodId,
        fileId: selectedFile?.id,
        data: {
          password: pwd
        }
      },
      {
        onSuccess: () => {
          // FileProcessingUpdate listener refetches files + funds.
          if (!isCustomReportType) refetchJurisdictions();
          toast.success('Successfuly unlocked');
          setSelectedFile(null);
        },
        onError: err => {
          toast.error(extractApiError(err, 'Unable to unlock this file.'));
        }
      }
    );
  };

  const jurisdictionHasBeenCreatedAlready = jurisdictions?.length > 0 && !isFormPFReportType;
  const formPFJurisdictionHasBeenCreatedAlready =
    isFormPFReportType && Boolean(formPFJurisdiction?.id && formPFJurisdiction?.sec_number);

  // AIFs ownership moved to the AddAIFs page (both scratch and automation
  // now use /project/quaters/:wf/:periodId/add-aifs for the AIFs step). The
  // Funds page therefore only services the Source Files step in scratch.
  // Stepper Next from here → Extraction (Custom included; Custom workflows
  // skip the AIFs/Jurisdictions stages, but the Source Files Next destination
  // is still Extraction).
  const handleNextClick = () => {
    navigate(`/data-extraction/${projectId}/${periodId}`);
  };

  const { classes } = useStyles();

  const onOpenEditProject = () => {
    setIsOpenEditProject(true);
    setProjectName(project?.name);
  };

  const onSubmitEditProject = e => {
    e.preventDefault();
    updateProject.mutate(
      {
        data: {
          name: projectName
        },
        id: project?.id
      },
      {
        onSuccess: () => {
          setProjectName('');
          setIsOpenEditProject(false);
          refetchWorkflow();
        },
        onError: err => {
          toast.error(
            'Something went wrong while changing the project name. Please make sure you have the right permissions'
          );
        }
      }
    );
  };

  const handleChange = event => {
    const filteredValue = event.target.value.replace(/[^a-zA-Z0-9 ~!@#$%^&*()_+=-]/g, '');
    setProjectName(filteredValue);
  };

  useEffect(() => {
    agentStore?.setCurrentScreen(WEB_PAGE_STATE_ENUMS.InputFundFiles);
  }, []);

  const onOpenBulkUpload = () => {
    uploadRef.current?.click();
  };

  const { setLabels, clearLabels } = useWorkflowChrome();

  // Stable ref so the stepper's Next-handler effect doesn't re-fire each render
  // (handleNextClick is a fresh closure every time).
  const handleNextClickRef = useRef(handleNextClick);
  useEffect(() => {
    handleNextClickRef.current = handleNextClick;
  });

  useEffect(() => {
    // Funds page is now Source-Files-only in the stepper flow — AIFs moved
    // to /project/quaters/:wf/:periodId/add-aifs (handled by the AddAIFs
    // page, which adapts to scratch via its own `template_type` check).
    // The legacy `?stage=source_files` URL param still arrives from the
    // stepper but is redundant now; we always highlight Source Files here.
    setLabels({
      projectLabel: project?.name,
      periodLabel: period?.year && period?.period ? `${period.year}, ${period.period}` : undefined,
      workflowId: projectId,
      periodId,
      activeStageKey: 'source_files',
      nextStepHandler: () => handleNextClickRef.current?.(),
      // Editable name lives in the toolbar's left slot. Only renders the
      // pencil affordance for scratch periods — automation/from-template
      // periods see the name as plain text.
      toolbarLeftContent: <EditableProjectName workflowId={projectId} period={period} />
    });
    return () => clearLabels();
  }, [
    project?.name,
    period?.year,
    period?.period,
    period?.template_type,
    projectId,
    periodId,
    setLabels,
    clearLabels
  ]);

  // Stepper's AIFs / Source Files steps deep-link here with ?fromStepper=1.
  // Normalize the URL on arrival: keep `periodId` + `stage` and strip the
  // sentinel plus any stale params (e.g. `tab`/`fileId`/`sheetId`/`extractId`
  // that some platform routing carries across pathnames). `stage=source_files`
  // (set by buildPath for the SOURCE_FILES stage) must survive so the page
  // continues to highlight Source Files in the stepper.
  useEffect(() => {
    if (searchParams.get('fromStepper') !== '1') return;
    const keep = ['periodId', 'stage'];
    const next = new URLSearchParams();
    keep.forEach(k => {
      const v = searchParams.get(k);
      if (v != null) next.set(k, v);
    });
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <Box data-testid="project-funds-container" p="16" bg="gray.0" h="calc(100vh - 68px)">
      <input
        ref={uploadRef}
        type="file"
        style={{ display: 'none' }}
        onChange={bulkUploadFiles}
        multiple
        accept={acceptedFileTypes}
      />
      {/* The inline "Edit Jurisdiction" / "Edit Fund Info" + "Next to
          Extraction" action row used to live here. The Next button's
          disabled state (`nextStepDisabled: !!hasUncompletedFiles`) and
          click handler are now wired into the unified workflow stepper via
          `setLabels` below, so the stepper's Next arrow does the same job.
          Jurisdictions editing lives on a dedicated page now
          (/project/:wf/jurisdictions?periodId=:p). */}

      <Box className={classes.borderedBox}>
        <Flex align="center" justify="space-between">
          {isOpenEditProject ? (
            <Flex onSubmit={onSubmitEditProject} component="form" align="center" gap="20px">
              <Input w="260px" required value={projectName} onChange={handleChange} />
              <Flex gap="8px">
                <ActionIcon
                  loading={updateProject.isLoading}
                  type="submit"
                  variant="white"
                  c="gray"
                  size="sm"
                >
                  <TbCheck fontSize="20px" color="#CED4DA" />
                </ActionIcon>

                <CloseButton
                  onClick={() => setIsOpenEditProject(false)}
                  variant="white"
                  c="#CED4DA"
                  size="sm"
                />
              </Flex>
            </Flex>
          ) : (
            <Flex py="8px" gap="8px" align="center">
              <Text fz="14px" truncate maw="550px" lh="20px" c="#000">
                {project?.name || ''}
              </Text>
              {project?.name && canManageWorkflow && (
                <TbPencil
                  onClick={onOpenEditProject}
                  cursor="pointer"
                  fontSize="20px"
                  color="#CED4DA"
                />
              )}
            </Flex>
          )}

          <Flex align="center" gap="16px">
            {isCustomReportType ? (
              <DropZone
                onDrop={files => bulkUploadFiles({ target: { files } })}
                variant="default"
                dragLabel="Drop source files to upload"
                disabled={isUploadingFiles || isLockedPeriod || !canManageWorkflow}
                accept={acceptedDropzoneTypes}
              >
                <PermissionGuard allowed={canManageWorkflow}>
                  <Button
                    size="sm"
                    leftSection={<TbUpload />}
                    variant="outline"
                    loading={uploadFundFiles.isLoading}
                  >
                    Upload Source Files
                  </Button>
                </PermissionGuard>
              </DropZone>
            ) : (
              <Tooltip
                disabled={Boolean(data?.length)}
                label="Please add fund names before uploading your file"
              >
                <DropZone
                  onDrop={files => bulkUploadFiles({ target: { files } })}
                  variant="compact"
                  dragLabel="Drop Here to upload files for all funds"
                  accept={acceptedDropzoneTypes}
                  disabled={
                    !data ||
                    data?.length === 0 ||
                    isUploadingFiles ||
                    isLockedPeriod ||
                    !canManageWorkflow
                  }
                  disableClick
                >
                  <PermissionGuard allowed={canManageWorkflow}>
                    <Button
                      className="upload-file-btn"
                      variant="transparent"
                      onClick={isCloudIntegrationEnabled ? openAddFilesModal : onOpenBulkUpload}
                      disabled={!data || data?.length === 0 || isUploadingFiles || isLockedPeriod}
                      size="xs"
                      leftSection={<TbUpload />}
                    >
                      {`Upload Files for All ${REPORT_NAMINGS.FUND[project?.report_type]}s`}
                    </Button>
                  </PermissionGuard>
                </DropZone>
              </Tooltip>
            )}
            {!isCustomReportType && (
              <PermissionGuard allowed={canManageWorkflow}>
                <Button
                  size="sm"
                  leftSection={<TbPlus fontSize="16px" />}
                  variant="outline"
                  onClick={openAddAIFs}
                  disabled={isLockedPeriod}
                >
                  Add {REPORT_NAMINGS.FUND[project?.report_type]}s
                </Button>
              </PermissionGuard>
            )}
          </Flex>
        </Flex>

        {!isCustomReportType && (
          <Alert
            w="fit-content"
            p="10px"
            variant="outline"
            color="blue"
            icon={<AiOutlineInfoCircle />}
            mt="16px"
          >
            You can add one or more {REPORT_NAMINGS.FUND[project?.report_type]}s to the list, and
            files can also be uploaded to the added {REPORT_NAMINGS.FUND[project?.report_type]}s
          </Alert>
        )}

        <Box mt="16px">
          {showCustomReportTypeTable ? (
            <Table
              onRowClick={() => {}}
              isLoading={isLoading || isLoadingCompany}
              columns={_customReportColumns}
              data={data}
              hasIndex={false}
              height="62vh"
            />
          ) : (
            <Table
              onRowClick={() => {}}
              isLoading={isLoading || isLoadingCompany}
              columns={_columns}
              data={data}
              height="62vh"
            />
          )}
        </Box>
      </Box>

      <Modal
        open={isOpenCreateModal}
        toggle={() => setOpenIsCreateModal(prev => !prev)}
        title="Add Fund"
      >
        <CreateProjectModalContainer>
          <form
            onSubmit={e => {
              e.preventDefault();
              handleAddFund();
            }}
          >
            <Input
              boxClass="box"
              label="Fund Name"
              placeholder="Type Fund"
              value={fundName}
              onChange={e => setFundName(e.target.value)}
            />

            <div className="actions">
              <Button disabled={createFund.isLoading}>Submit</Button>
            </div>
          </form>
        </CreateProjectModalContainer>
      </Modal>

      <AddFilesSourceModal
        opened={isAddFilesModalOpen}
        onClose={closeAddFilesModal}
        title={`Add Files For All ${REPORT_NAMINGS.FUND?.[project?.report_type] || 'AIF'}s`}
        description={`Choose how you want to add files for all ${
          REPORT_NAMINGS.FUND?.[project?.report_type] || 'AIF'
        }s.`}
        onUploadFromDevice={handleAddFromLocal}
        onImportFromSource={handleAddFromIntegration}
        isCloudIntegrationEnabled={isCloudIntegrationEnabled}
      />

      <CloudImportModal
        opened={isCloudModalOpen}
        onClose={closeCloudModal}
        title="Import files"
        providers={connectedProviders}
        previewProviders={providers}
        selectedProvider={selectedProvider}
        onSelectProvider={providerKey => {
          setSelectedProvider(providerKey);
          setSelectedConnectionId('');
          setSelectedCloudFiles([]);
          setCloudPath('');
          setCloudFolderId('');
          setCloudFolderIdTrail([]);
          setCloudFolderTrail([]);
          setCloudQuery('');
        }}
        connections={allConnections}
        hasAnyConnections={allConnections.length > 0}
        selectedProviderConnections={selectedProviderConnections}
        selectedConnectionId={selectedConnectionId}
        onSelectConnection={connectionId => {
          setSelectedConnectionId(connectionId);
          setSelectedCloudFiles([]);
          setCloudPath('');
          setCloudFolderId('');
          setCloudFolderIdTrail([]);
          setCloudFolderTrail([]);
          setCloudQuery('');
        }}
        searchValue={cloudQuery}
        onSearchChange={value => setCloudQuery(value)}
        onSearchSubmit={refetchCloudFiles}
        onRefreshConnections={refetchConnections}
        onConnectProvider={handleConnectProvider}
        cloudPath={cloudPath}
        isCloudFolderNavigationEnabled={isCloudFolderNavigationEnabled}
        onNavigateBack={handleCloudBack}
        files={visibleCloudFiles}
        selectedCloudFiles={selectedCloudFiles}
        onFileClick={handleCloudItemClick}
        acceptedMimeTypes={new Set(Object.keys(acceptedDropzoneTypes))}
        isFetchingConnections={isFetchingConnections}
        isFetchingCloudFiles={isFetchingCloudFiles}
        onImport={handleImportCloudFiles}
        isImporting={importCloudFiles.isLoading}
        onShowMoreIntegrations={() => navigate('/integrations')}
      />

      <NewDeleteConfirmModal
        title="Delete File"
        description={`Are you sure you want to permanently delete ${deletableFile?.name}?`}
        isOpen={Boolean(deletableFile)}
        onClose={() => setDeletableFile()}
        submitLabel="Yes, Delete File"
        cancelLabel="Cancel"
        type="delete"
        onConfirm={handleDelete}
        isLoading={deleteFundFile.isLoading}
      />

      <PasswordModal
        isOpen={!!selectedFile}
        onClose={() => setSelectedFile(null)}
        title={`
File <span style="color: #276EF1;">“${selectedFile?.name}”</span> is locked.Please enter the passwords to proceed with the upload.`}
        image={protectedFile}
        cancelLabel="Cancel"
        submitLabel="Submit"
        onConfirm={handleUnblockFile}
        isLoading={setPasswordToFile.isLoading}
      />

      <SkipPasswordModal
        isOpen={isSkipPasswordModalOpen}
        fileName={protectedFiles?.[protectedFileNumber]?.name}
        title={`${protectedFiles.length} files are locked, please enter the password`}
        cancelLabel="Ignore this file"
        submitLabel={`Submit ${protectedFileNumber + 1}/${protectedFiles.length}`}
        onCancel={onSkipFile}
        onConfirm={onUnblockSkipFile}
        onCancelAll={onSkipAllFiles}
        isLoading={setPasswordToFile.isLoading}
        isSkipping={deleteFundFile.isLoading}
        isDeletingAllProtectedFiles={isDeletingAllProtectedFiles}
      />

      <Drawer
        opened={openedAddAIFs}
        onClose={handleCloseAddAifs}
        position="right"
        title={`Add ${REPORT_NAMINGS.FUND[project?.report_type]}s`}
      >
        <AddAIFs
          handleCreate={handleCreateFunds}
          isLoading={createFundBulk.isLoading}
          selectedReportType={project?.report_type}
          expression={expression}
          setExpression={setExpression}
        />
      </Drawer>

      <DuplicateFilesModal
        isOpen={duplicateFiles.length > 0}
        duplicates={duplicateFiles}
        onClose={() => {
          setDuplicateFiles([]);
          setPendingUploadFiles(null);
          if (uploadRef.current) uploadRef.current.value = '';
        }}
        onProceed={handleDuplicateModalProceed}
        isLoading={isCheckingDuplicates}
      />
    </Box>
  );
}
